// Copyright (c) Microsoft. All rights reserved.

import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
import { GetResponseOptions } from '../../../libs/hooks/useChat';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import Loading from '../../views/Loading';
import { ChatHistoryItem } from './ChatHistoryItem';

const useClasses = makeStyles({
    root: {
        ...shorthands.gap(tokens.spacingVerticalM),
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '900px',
        width: '100%',
        justifySelf: 'center',
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
    },
});

interface ChatHistoryProps {
    loadingMessages: boolean;
    messages: IChatMessage[];
    onGetResponse: (options: GetResponseOptions) => Promise<void>;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({ loadingMessages, messages, onGetResponse }) => {
    const classes = useClasses();

    return (
        <div className={classes.root}>
            {
                loadingMessages ?
                    <Loading text="Loading messages..." />
                    :
                    messages
                        .slice()
                        // .sort((a, b) => a.timestamp - b.timestamp)
                        .map((message, index) => (
                            <ChatHistoryItem
                                key={message.timestamp}
                                message={message}
                                getResponse={onGetResponse}
                                messageIndex={index}
                            />
                        ))
            }
        </div>
    );
};
